var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lab-task',[_c('lab-sim',{attrs:{"d-value":_vm.dValue,"unknown-gas-symbol":_vm.unknownGasSymbol,"lab-name":"atomic-emission-spectroscopy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }